export default __webpack_public_path__ + "static/gsologo-657b90fd5b87811bd833761a7bb57cd2.png";